import _ from "lodash";
import { IApiRequest } from "../Types/IApiRequest";
import { authService } from "../../Auth";

/**
 * Helper clas used to build semantic API requests
 */
export class ApiRequest implements IApiRequest {
  queryParams: { [key: string]: string } = {};

  headers: { [key: string]: string } = {};

  url: URL;

  body?: any;

  promises: Promise<any>[] = [];

  private constructor(url: URL) {
    this.url = url;
  }

  static fromPath(path: string): IApiRequest {
    const currentUrl = new URL(window.location.href);
    return new ApiRequest(new URL(path, currentUrl.origin));
  }

  static fromUrl(url: string): IApiRequest {
    return new ApiRequest(new URL(url));
  }

  withQueryParams(queryParams: { [key: string]: string }): IApiRequest {
    this.addQueryParams(queryParams);
    return this;
  }

  withQueryParam(name: string, value: string) {
    this.addQueryParams({ [name]: value });
    return this;
  }

  withHeaders(headers: { [key: string]: string }): IApiRequest {
    this.addHeaders(headers);
    return this;
  }

  withHeader(name: string, value: string) {
    this.addHeaders({ [name]: value });
    return this;
  }

  withJson(json: string | object): IApiRequest {
    if (typeof json === "string") this.body = json;
    else this.body = JSON.stringify(json);
    this.withHeaders({ "Content-Type": "application/json" });
    return this;
  }

  withFormData(data: FormData | FormData[]): IApiRequest {
    this.body = data;
    // this.withHeaders({ 'Content-Type': 'multipart/form-data' })
    return this;
  }

  withAuthHeader(): IApiRequest {
    const promise = authService
      .getToken()
      .then(token => {
        if (!token) throw new Error("Could not load bearer token for Authentication header");
        else this.addHeaders({ Authorization: `Bearer ${token}` });
      })
      .catch(error => {
        throw new Error(error);
      });
    this.promises.push(promise);
    return this;
  }

  get(): Promise<Response> {
    return this.sendRequest("GET");
  }

  post(): Promise<Response> {
    return this.sendRequest("POST");
  }

  put(): Promise<Response> {
    return this.sendRequest("PUT");
  }

  delete(): Promise<Response> {
    return this.sendRequest("DELETE");
  }

  private addHeaders(headers: { [key: string]: string }): void {
    this.headers = _.merge(this.headers, headers);
  }

  private addQueryParams(queryParams: { [key: string]: string }): void {
    this.queryParams = _.merge(this.queryParams, queryParams);
  }

  private async sendRequest(method: "GET" | "POST" | "PUT" | "DELETE"): Promise<Response> {
    await Promise.all(this.promises);
    _.forEach(this.queryParams, (value, key) => this.url.searchParams.append(key, value));

    return fetch(this.url.href, {
      body: this.body,
      headers: this.headers,
      method
    });
  }
}
